import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { PRODUCTS, SERVICE } from '~/src/constants';
import { connectedProducts } from '~/src/helpers/clientInfo';

import {
    ButtonWrapper,
    Content,
    Footnote,
    Section,
    Slogan,
    TelevisionStyled,
    Text,
    Title,
} from  './styled';

class SectionWelcome extends Component {
    setButtonText = () => {
        const connectedProduct = connectedProducts(this.props.auth, PRODUCTS.content, SERVICE.viewManagement);
        if (this.props.auth.isAuth && connectedProduct) {
            return 'Управление услугой';
        }
            return 'Подключить услугу';
    }

    render() {
        const { activeSlide, prevSlide, onTelevisionClick, onButtonClick, breakpoint, catchup, ...props } = this.props;

        const isActive = (activeSlide.link === 'main');
        const from = (isActive) ? prevSlide.link : null;
        const to = (!isActive) ? activeSlide.link : null;

        return (
            <Section isActive={isActive} from={from} to={to} {...props}>
                <Content>
                    <Slogan>Услуга «Управляй&nbsp;просмотром»</Slogan>
                    <Title>Архив передач ТВ каналов</Title>
                    <Text>Ставьте фильм или матч на паузу, если нужно отлучиться. Перематывайте рекламу. Смотрите в архиве передач то, что пропустили на ТВ.</Text>
                    <Footnote>*Услуга доступна на всех ТВ-каналах, кроме местных каналов (с 21 по 32 кнопку),
                        канала MyZen 4K и первых 20 ТВ-каналов (каналы первого и второго мультиплекса).
                        По решению правообладателей трансляция этих каналов в режиме «Управляй просмотром»
                        приостановлена через мобильные приложения Дом.ру Movix для iOS, Android, Смарт ТВ и на сайте movix.ru.
                    </Footnote>
                    {!catchup.info['0']?.activate && <ButtonWrapper>
                        <BaseButton type='accent' text={this.setButtonText()} onClick={onButtonClick} />
                    </ButtonWrapper>}
                </Content>

                <TelevisionStyled mod='sectionMain' breakpoint={breakpoint} onClick={onTelevisionClick}/>
            </Section>
        );
    }
}

const mapStateToProps = ({ city, auth, catchup }) => ({
    city: city.currentCity,
    auth,
    catchup,
});

export default connect(
    mapStateToProps,
)(SectionWelcome);
